import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-5xl" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800" }, " Pay HOA Dues ", -1)
const _hoisted_5 = { class: "text-primary-500 mt-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Due by ")
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-center py-12"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-4 border-primary-200 border-t-accent-600" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "max-w-3xl mx-auto mb-6"
}
const _hoisted_12 = { class: "bg-amber-50 border border-amber-300 rounded-xl p-6" }
const _hoisted_13 = { class: "flex items-start gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-amber-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    })
  ])
], -1)
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-amber-800 mb-1" }, " Past Dues Outstanding ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-amber-700 mb-4" }, " You have outstanding dues from previous years that need to be paid. ", -1)
const _hoisted_18 = { class: "space-y-3" }
const _hoisted_19 = { class: "font-semibold text-primary-800" }
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-primary-500 mt-1"
}
const _hoisted_21 = { class: "text-sm text-primary-600 mt-2 space-y-1" }
const _hoisted_22 = {
  key: 0,
  class: "text-amber-600"
}
const _hoisted_23 = { class: "flex flex-col items-end gap-2" }
const _hoisted_24 = { class: "text-xl font-bold text-primary-800" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "grid lg:grid-cols-2 gap-8"
}
const _hoisted_27 = { class: "bg-white rounded-xl border border-amber-200 shadow-soft p-6" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-4\"><div class=\"w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center\"><svg class=\"w-4 h-4 text-amber-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><h2 class=\"text-lg font-heading font-semibold text-primary-800\"> Past Dues Payment </h2></div>", 1)
const _hoisted_29 = { class: "bg-amber-50 rounded-lg p-4 mb-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-amber-700 mb-1" }, "Paying past dues for:", -1)
const _hoisted_31 = { class: "text-lg font-semibold text-primary-800" }
const _hoisted_32 = {
  key: 0,
  class: "text-sm text-amber-600 mt-2"
}
const _hoisted_33 = { class: "space-y-3 border-t border-primary-100 pt-4" }
const _hoisted_34 = { class: "flex justify-between text-primary-600" }
const _hoisted_35 = {
  key: 0,
  class: "flex justify-between text-amber-600"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Late Fee", -1)
const _hoisted_37 = { class: "flex justify-between text-primary-600" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "CC Processing Fee", -1)
const _hoisted_39 = { class: "flex justify-between text-lg font-semibold text-primary-800 pt-3 border-t border-primary-200" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Total Amount Due", -1)
const _hoisted_41 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800 mb-4" }, " Payment Details ", -1)
const _hoisted_43 = {
  key: 0,
  class: "flex flex-col items-center py-8"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-4 border-primary-200 border-t-amber-600 mb-4" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-600" }, "Loading secure payment form...", -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "bg-red-50 border border-red-200 rounded-lg p-4"
}
const _hoisted_48 = { class: "text-red-700" }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = ["onSubmit"]
const _hoisted_51 = {
  ref: "pastDueCardElement",
  id: "pastDueCardHome",
  class: "mb-4"
}
const _hoisted_52 = {
  key: 0,
  class: "text-red-500 text-sm mb-4"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 3,
  class: "max-w-2xl mx-auto"
}
const _hoisted_57 = { class: "bg-green-50 border border-green-200 rounded-xl p-6 mb-6" }
const _hoisted_58 = { class: "flex items-center gap-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-6 h-6 text-green-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 13l4 4L19 7"
    })
  ])
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-green-800" }, " You're All Paid Up! ", -1)
const _hoisted_61 = { class: "text-green-700" }
const _hoisted_62 = { class: "mt-4 pt-4 border-t border-green-200" }
const _hoisted_63 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm" }
const _hoisted_64 = { class: "text-green-700" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("strong", null, "Amount:", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("strong", null, "Date:", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("strong", null, "Method:", -1)
const _hoisted_68 = {
  key: 0,
  class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-800 mb-4" }, " Payment History ", -1)
const _hoisted_70 = { class: "space-y-3" }
const _hoisted_71 = { class: "font-medium text-primary-800" }
const _hoisted_72 = { class: "text-sm text-primary-500" }
const _hoisted_73 = { class: "text-right" }
const _hoisted_74 = { class: "font-semibold text-primary-800" }
const _hoisted_75 = { class: "text-xs text-primary-400" }
const _hoisted_76 = {
  key: 4,
  class: "grid lg:grid-cols-2 gap-8"
}
const _hoisted_77 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800 mb-4" }, " Payment Summary ", -1)
const _hoisted_79 = { class: "bg-primary-50 rounded-lg p-4 mb-6" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500 mb-1" }, "Paying for property:", -1)
const _hoisted_81 = { class: "text-lg font-semibold text-primary-800" }
const _hoisted_82 = { class: "space-y-3 border-t border-primary-100 pt-4" }
const _hoisted_83 = { class: "flex justify-between text-primary-600" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", null, "Association Dues", -1)
const _hoisted_85 = { class: "flex justify-between text-primary-600" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", null, "CC Processing Fee", -1)
const _hoisted_87 = { class: "flex justify-between text-lg font-semibold text-primary-800 pt-3 border-t border-primary-200" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", null, "Total Amount Due", -1)

import MakePayment from "@/components/profile/MakePayment.vue";
import { useAuthStore } from "@/stores/auth";
import { HoodApi } from "@/services/HoodApi";
import { StripeService } from "@/services/StripeService";
import { ref, computed, onMounted, nextTick } from "vue";
import type { StripeElements } from "@stripe/stripe-js";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
const house = ref(auth.user_details);

const loading = ref(true);
const paymentStatus = ref<PaymentStatusResponse | null>(null);
const showPaymentForm = ref(false);
const dueDate = ref("Loading...");
const duesAmount = ref(55);
const processingFee = ref(1.95);
const totalAmount = ref(56.95);

// Past dues state
const selectedPastDue = ref<PastDuesAuthorization | null>(null);
const pastDuePaymentLoading = ref(false);
const pastDuePaymentError = ref("");
const pastDueSubmitting = ref(false);
const stripeError = ref("");
let pastDueElements: StripeElements | null = null;

// Computed property to check if there are past dues
const pastDuesAuthorizations = computed(() => {
  return paymentStatus.value?.past_dues_authorizations || [];
});

const hasPastDues = computed(() => {
  return pastDuesAuthorizations.value.length > 0;
});

const fetchDuesSettings = async () => {
  try {
    const settings = await HoodApi.fetch_dues_settings();
    dueDate.value = settings.due_date_formatted;
    duesAmount.value = settings.amount_dollars;
    processingFee.value = settings.processing_fee_dollars;
    totalAmount.value = settings.total_dollars;
  } catch (err) {
    console.error("Failed to fetch dues settings:", err);
    dueDate.value = "September 1, 2026";
    // Keep fallback values
  }
};

const fetchPaymentStatus = async () => {
  try {
    paymentStatus.value = await HoodApi.fetch_my_payment_status();
  } catch (err) {
    console.error("Failed to fetch payment status:", err);
    // If we can't get status, show the payment form
    showPaymentForm.value = true;
  } finally {
    loading.value = false;
  }
};

const formatDate = (dateStr?: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const formatPaymentType = (type?: string) => {
  const types: Record<string, string> = {
    online: "Credit Card",
    check: "Check",
    cash: "Cash",
  };
  return types[type || ""] || type || "Unknown";
};

// Past dues payment functions
const selectPastDue = async (auth: PastDuesAuthorization) => {
  selectedPastDue.value = auth;
  await initPastDuePayment();
};

const cancelPastDuePayment = () => {
  selectedPastDue.value = null;
  pastDueElements = null;
  pastDuePaymentError.value = "";
  stripeError.value = "";
};

const initPastDuePayment = async () => {
  if (!selectedPastDue.value) return;

  pastDuePaymentLoading.value = true;
  pastDuePaymentError.value = "";

  try {
    const result = await StripeService.create_past_dues_elements(
      selectedPastDue.value.id
    );
    pastDueElements = result.elements;

    // Wait for Vue to render the DOM, then mount Stripe element
    pastDuePaymentLoading.value = false;
    await nextTick();

    // Double-check the element exists before mounting
    const mountElement = document.getElementById("pastDueCardHome");
    if (pastDueElements && mountElement) {
      pastDueElements.create("payment").mount("#pastDueCardHome");
    } else {
      console.error("Mount element not found, retrying...");
      // Fallback: try again after a short delay
      setTimeout(() => {
        if (pastDueElements) {
          pastDueElements.create("payment").mount("#pastDueCardHome");
        }
      }, 200);
    }
  } catch (err: any) {
    console.error("Failed to initialize past dues payment:", err);
    pastDuePaymentError.value =
      err.response?.data?.error ||
      err.message ||
      "Failed to load payment form. Please try again.";
    pastDuePaymentLoading.value = false;
  }
};

const submitPastDuePayment = async () => {
  if (!pastDueElements) return;

  pastDueSubmitting.value = true;
  stripeError.value = "";

  try {
    await StripeService.submit_payment(pastDueElements);
  } catch (err: any) {
    console.error("Payment error:", err);
    stripeError.value = err.message || "Payment failed. Please try again.";
    pastDueSubmitting.value = false;
  }
};

onMounted(() => {
  fetchPaymentStatus();
  fetchDuesSettings();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(dueDate.value), 1)
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : (_unref(hasPastDues) && !selectedPastDue.value && !showPaymentForm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pastDuesAuthorizations), (auth) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: auth.id,
                          class: "bg-white border border-amber-200 rounded-lg p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(auth.dues_year) + " Dues ", 1),
                            (auth.notes)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(auth.notes), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("p", null, "Base Amount: $" + _toDisplayString((auth.amount_cents / 100).toFixed(2)), 1),
                              (auth.penalty_cents > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Late Fee: $" + _toDisplayString((auth.penalty_cents / 100).toFixed(2)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, "Processing Fee: $" + _toDisplayString((auth.processing_fee_cents / 100).toFixed(2)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", _hoisted_24, " $" + _toDisplayString((auth.grand_total_cents / 100).toFixed(2)), 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (selectPastDue(auth)),
                              class: "px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-lg transition-colors"
                            }, " Pay Now ", 8, _hoisted_25)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : (selectedPastDue.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("p", _hoisted_31, _toDisplayString(selectedPastDue.value.dues_year) + " - " + _toDisplayString(paymentStatus.value?.house?.full_address ||
                `${house.value?.my_house?.house_number} ${house.value?.my_house?.street}`), 1),
                    (selectedPastDue.value.notes)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(selectedPastDue.value.notes), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", null, _toDisplayString(selectedPastDue.value.dues_year) + " Dues", 1),
                      _createElementVNode("span", null, "$" + _toDisplayString((selectedPastDue.value.amount_cents / 100).toFixed(2)), 1)
                    ]),
                    (selectedPastDue.value.penalty_cents > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("span", null, "$" + _toDisplayString((selectedPastDue.value.penalty_cents / 100).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("span", null, "$" + _toDisplayString((selectedPastDue.value.processing_fee_cents / 100).toFixed(2)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", null, "$" + _toDisplayString((selectedPastDue.value.grand_total_cents / 100).toFixed(2)), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: cancelPastDuePayment,
                    class: "mt-4 text-sm text-primary-500 hover:text-primary-700"
                  }, " ← Back to payment options ")
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  (pastDuePaymentLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
                    : (pastDuePaymentError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("p", _hoisted_48, _toDisplayString(pastDuePaymentError.value), 1),
                          _createElementVNode("button", {
                            onClick: initPastDuePayment,
                            class: "mt-3 text-sm text-red-600 hover:text-red-800 underline"
                          }, " Try again ")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("form", {
                            onSubmit: _withModifiers(submitPastDuePayment, ["prevent"])
                          }, [
                            _createElementVNode("div", _hoisted_51, null, 512),
                            (stripeError.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(stripeError.value), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              type: "submit",
                              disabled: pastDueSubmitting.value,
                              class: "w-full py-3 bg-amber-600 hover:bg-amber-700 disabled:bg-amber-300 text-white font-semibold rounded-lg transition-colors"
                            }, [
                              (pastDueSubmitting.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Processing..."))
                                : (_openBlock(), _createElementBlock("span", _hoisted_55, "Pay $" + _toDisplayString((selectedPastDue.value.grand_total_cents / 100).toFixed(2)), 1))
                            ], 8, _hoisted_53)
                          ], 40, _hoisted_50)
                        ]))
                ])
              ]))
            : (paymentStatus.value?.has_paid && !showPaymentForm.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", null, [
                        _hoisted_60,
                        _createElementVNode("p", _hoisted_61, " Your " + _toDisplayString(paymentStatus.value.current_year) + " HOA dues have been paid. ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("p", null, [
                            _hoisted_65,
                            _createTextVNode(" $" + _toDisplayString(paymentStatus.value.payment?.amount.toFixed(2)), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_66,
                            _createTextVNode(" " + _toDisplayString(formatDate(paymentStatus.value.payment?.date)), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_67,
                            _createTextVNode(" " + _toDisplayString(formatPaymentType(paymentStatus.value.payment?.type)), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPaymentForm.value = true)),
                          class: "text-green-700 hover:text-green-900 underline text-sm"
                        }, " Make another payment → ")
                      ])
                    ])
                  ]),
                  (
            paymentStatus.value.payment_history &&
            paymentStatus.value.payment_history.length > 1
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentStatus.value.payment_history, (payment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: payment.date,
                              class: "flex items-center justify-between py-2 border-b border-primary-100 last:border-0"
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_71, _toDisplayString(payment.year) + " Dues ", 1),
                                _createElementVNode("p", _hoisted_72, _toDisplayString(formatDate(payment.date)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("p", _hoisted_74, " $" + _toDisplayString(payment.amount.toFixed(2)), 1),
                                _createElementVNode("p", _hoisted_75, _toDisplayString(formatPaymentType(payment.type)), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("p", _hoisted_81, _toDisplayString(paymentStatus.value?.house?.full_address ||
                `${house.value?.my_house?.house_number} ${house.value?.my_house?.street}`), 1)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("span", null, "$" + _toDisplayString(duesAmount.value.toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createElementVNode("span", null, "$" + _toDisplayString(processingFee.value.toFixed(2)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _createElementVNode("span", null, "$" + _toDisplayString(totalAmount.value.toFixed(2)), 1)
                      ])
                    ]),
                    (paymentStatus.value?.has_paid)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPaymentForm.value = false)),
                          class: "mt-4 text-sm text-primary-500 hover:text-primary-700"
                        }, " ← Back to payment status "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(MakePayment, { class: "w-full" })
                  ])
                ]))
    ])
  ]))
}
}

})